<template>
  <div class="po-f pl10 pr10 bg-w sidebar" :class="rightShow == '1' ? 'rightAcv' : 'noRightAcv'" style="color: #4D4D4D;" v-show="$route.name ? !($route.name.indexOf('/management') > -1) : false" v-if="$route.name!=='cassso'">
    <div class="w100 mt20 mb20 tx-c cu-p"  @click="$router.push({path:'/mine/myAffair'})" v-if="hasItem('/mine/myAffair')">
      <el-badge v-if="tabJson.mytasks>0" :value="tabJson.mytasks" :max="99" class="item">
          <img :src="`${baseUrl}images/hcxy-icon-15.png`" alt="" height="20">
      </el-badge>
        <img v-else :src="`${baseUrl}images/hcxy-icon-15.png`" alt="" height="20">
          <p class="mt5 font-14">办事进度</p>
    </div>
    <div class="w100 mt20 mb20 tx-c cu-p" @click="$router.push({path:'/QAHelper'})" v-if="hasItem('/QAHelper')">
      <img :src="`${baseUrl}images/hcxy-icon-16.png`" alt="" height="20">
      <p class="mt5 font-14">智能问答</p>
    </div>
    <div class="w100 mt20 mb20 tx-c cu-p" @click="$router.push({path:'/mine/collect'})" v-if="hasItem('/mine/collect')">
      <img :src="`${baseUrl}images/hcxy-icon-18.png`" alt="" height="20">
      <p class="mt5 font-14">我的收藏</p>
    </div>
    <div class="w100 mt20 mb20 tx-c cu-p" @click="$router.push({path:'/addAdvice'})" v-if="hasItem('/addAdvice')">
      <img :src="`${baseUrl}images/hcxy-icon-19.png`" alt="" height="20">
      <p class="mt5 font-14">投诉建议</p>
    </div>
    <div class="claRight">
      <i v-if="rightShow == '2'" @click="setClass('1')" class="el-icon-d-arrow-right fc"></i>
      <i v-if="rightShow == '1'" @click="setClass('2')" class="el-icon-d-arrow-left fc"></i>
    </div>
  </div>
</template>

<script>
    import {bpmnCountPersonProcess} from '@/api/bpmnApi/bpmn';
import { mapGetters } from "vuex";
export default {
  name: "Sidebar",
  components: {},
  props: {},
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      hidePath: ["/management"],
      tabJson:{},
        rightShow: '2'
    };
  },
  computed: {
    ...mapGetters(["userData"]),
  },
  created() {},
  mounted() {
      this.getBpmnCountPersonProcess();
  },
  destroyed() {},
  methods: {
      setClass(val){
          this.rightShow = val
      },
      getBpmnCountPersonProcess(){
          bpmnCountPersonProcess().then(({data})=>{
              if(data.code==0){
                  this.tabJson =data.data||{}
              }else{


              }
          }).catch(err=>{
          })
      },
      hasItem(path){
        return (this.userData.routerData||[]).includes(path)
      },
      isAdmin(){
        return (this.userData.roleCodes||[]).includes('ROLE_ADMIN')
      },
  },
  watch: {
      $route(){
          this.getBpmnCountPersonProcess();
      }
  },
  filters: {},
};
</script>

<style scoped lang="less">
.sidebar {
  right: 0;
  top: calc(50% - 180px);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  z-index: 10;
}
.rightAcv{
  right: -80px;
}
.noRightAcv{
  right: 0;
}
  .claRight{
    cursor: pointer;
    position: absolute;
    top: 5px;
    left: -25px;
    background-color: #d9d9d9;
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
    .fc {
      font-size: 24px;
      color: #ffffff
    }
  }
</style>
